import * as _ from "lodash";

import { formatPrice } from "src/core/prices/utils/price-helpers";
import { IOrder } from "src/core/orders/api/orders.api";

import { CreditRequestRowType } from "../context/CreditRequestContext";
import { CreditRequestStatus } from "../api/credit-request.api";

/**
 * Calculates the total price credited on an order
 *
 * @param credits
 * @param type
 * @param orderLines
 * @returns
 */
export const creditRequestedPrice = (order: IOrder, credits: CreditRequestRowType[], type: "approved" | "requested"): string => {
  const total = _.reduce(credits, (currentTotal, cred) => {
    const orderLine = _.find(order.orderLines, ol => ol.id === cred.orderLineId);

    if (cred.status === CreditRequestStatus.Rejected) {
      return currentTotal;
    }

    if (type === "requested") {
      return currentTotal + ((orderLine?.price || 0) * cred.quantityRequested);
    } else {
      return currentTotal + ((orderLine?.price || 0) * (cred.quantityApproved || 0));
    }
  }, 0);

  return formatPrice(total, 2);
};
